import { createRoute } from '@tanstack/react-router'

import { areaRoute } from '@/app/routes/area-layout'
import { lazyPage } from '@/lib/lazy-page'

export const EAutomateSettings = lazyPage(
  () => import('./features/eautomate-settings/eautomate-settings.lazy'),
  'EAutomateSettings',
)

export const eautomateSettingsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'integrations/eautomate',
  component: EAutomateSettings,
  staticData: { title: 'e-automate' },
})
